<script setup lang="ts">
import './assets/style.scss'
import { useModel } from './../model/model.ts'
import { VModal } from '@/shared/ui'
import { onMounted, ref } from 'vue'
import { ObjectSearch } from '@/widgets'
import { useHelpers } from '@/shared/lib'
import { useAuth } from '@/entities/Auth'
import { useSendForm } from './../model/api.ts'
import { ObjectTypeIds } from '@/entities/Object'

const model = useModel()
const auth = useAuth()
const { numberList } = useHelpers()
const { sendForm, isPending } = useSendForm()

const valid = ref(false)

/**
 * Функция обработчик отправки формы
 */
const submitHandler = () => {
  sendForm(
    {
      ...model.data,
      json: model.generateJSON(),
    },
    valid.value,
  ).then(model.closeForm)
}

/**
 * Устанавливаем группу по умолчанию
 */
onMounted(() => {
  model.setGroup(auth.user?.object_group.id || 1)
})
</script>

<template>
  <VModal v-model="model.openForm" :max-width="450" :title="$t('itf.add_schedules')">
    <VForm class="pt-2" v-model="valid" @submit.prevent="submitHandler">
      <ObjectSearch
        v-model="model.data.group_object_list_id"
        :label="$t('itf.select_root_object')"
        :object_type="ObjectTypeIds.GROUPS"
      />

      <VSelect
        v-model="model.data.object_type_id"
        :label="$t('itf.device_type')"
        :items="model.deviceTypes"
        item-title="name"
        item-value="id"
      />

      <VSelect
        v-model="model.data.output_count"
        :label="$t('itf.outputs_count')"
        :items="numberList(10)"
      />

      <VTextField
        v-model="model.data.name"
        :label="$t('itf.name_label')"
        :rules="model.rules.name"
      />

      <VTextarea v-model="model.data.description" :label="$t('itf.description')" />

      <VTextField
        type="number"
        v-model="model.data.interval"
        :label="$t('itf.schedules_interval')"
      />

      <div class="form__btn_right mt-4">
        <VBtn type="submit" :loading="isPending">{{ $t('itf.add') }}</VBtn>

        <VBtn color="default" @click="model.openForm = false">
          {{ $t('itf.close') }}
        </VBtn>
      </div>
    </VForm>
  </VModal>
</template>
